import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default function AboutHeader() {
  useScrollToTop();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="about-header relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="w-full flex justify-center"
        >
          <motion.hr
            initial={{ width: 0 }}
            animate={{ width: "50%" }}
            transition={{ duration: 1.5 }}
            className="about-title-hr border-t-2 border-white w-1/2"
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0, color: "white" }}
          transition={{ duration: 1 }}
          className="aboutheader-title text-5xl font-bold md:text-6xl lg:text-7xl mt-4"
        >
          Ethiccraft Club
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="w-full flex justify-center mt-4"
        >
          <motion.hr
            initial={{ width: 0 }}
            animate={{ width: "50%" }}
            transition={{ duration: 1.5 }}
            className="about-title-hr border-t-2 border-white w-1/2"
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0, color: "white" }}
          transition={{ duration: 1, delay: 0.5 }}
          className="about-subtitle mt-4 text-lg md:text-xl lg:text-2xl"
        >
          CRAFTING CAREERS WITH CHARACTER
        </motion.p>
      </div>
    </div>
  );
}